import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';
import nbTranslation from './locales/nb-NO.json';
import nnTranslation from './locales/nn-NO.json';
import { invariant } from '../util/invariant';
import { getVariableFromContextEnvironment } from '../runtime/contextEnvironmentVariables';

// Derives every dot-notation leaf path from the primary translation JSON (en.json),
// e.g. 'HelpChat.Unavailable' | 'HelpChat.TimedOut' | ...
type DotPaths<T, P extends string = ''> = T extends string | number | boolean
  ? P
  : { [K in keyof T & string]: DotPaths<T[K], P extends '' ? K : `${P}.${K}`> }[keyof T & string];

export type I18nKey = DotPaths<typeof enTranslation>;

let i18nInitialized = false;

export async function initializeI18n(): Promise<void> {
  if (i18nInitialized) {
    return;
  }
  try {
    await i18next
      .use(LanguageDetector)
      .init({
        debug: Boolean(getVariableFromContextEnvironment('VITE_I18NEXT_DEBUG')),
        load: 'languageOnly',
        fallbackLng: 'en',
        returnNull: false,
        resources: {
          en: { translation: enTranslation },
          nb: { translation: nbTranslation },
          nn: { translation: nnTranslation },
          fr: { translation: frTranslation },
        },
      });
    i18nInitialized = true;
  } catch (error) {
    console.error('Error initializing i18next', error);
  }
}

export function getI18n() {
  invariant(i18nInitialized, 'i18n must be initialized before use');
  return i18next;
}
